import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';
import WavePattern from '../../../../assets/background/wave-pattern.png';

const style = () =>
  createStyles({
    container: {
      minHeight: '93px',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '70%',
      backgroundColor: 'blue',
      borderRadius: palette.borderRadius.default,
      boxSizing: 'border-box',
      padding: '10px 20px',
      color: palette.text.white,
      backgroundImage: `url(${WavePattern})`,
      backgroundSize: 'cover',
      boxShadow: palette.shadows.boxInnerShadow,
      cursor: 'pointer',
      '@media (max-width: 900px)': {
        width: '100%',
        flexDirection: 'column',
        gap: '1rem'
      },
      transition: '0.5s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow:
          'inset 4px 4px 4px rgba(255, 255, 255, 0.45), inset 0px 4px 4px rgba(255, 255, 255, 0.45)'
      }
    },
    classContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 900px)': {
        alignItems: 'center'
      }
    },
    name: {
      fontSize: '2rem',
      fontWeight: 700,
      color: palette.text.white
    },
    infosContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
      gap: '10px',
      '@media (max-width: 425px)': {
        flexDirection: 'column'
      }
    },
    iconTextContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '5px',
      '&>p': {
        fontWeight: 600,
        fontSize: '1rem'
      }
    },
    accessContainer: {
      display: 'flex',
      gap: '15px',
      justifyContent: 'center',
      alignItems: 'center',
      '&>p': {
        fontWeight: 600,
        fontSize: '1rem',
        textAlign: 'center'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
